import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Subject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { EnvironmentService } from 'src/app/core/enviroment/environment.service';
import { IAddress } from 'src/app/core/models/properties';

@Injectable({
  providedIn: 'root'
})
export class PropertiesService {

  public uri = this.environmentService.getEnvVar('api_products');
  public sendList = new Subject<any>();
  public requestForm = new Subject<any>();
  public requestFormValidator = new Subject<any>();

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) { }

  public getZipCode(data: string): Observable<any> {
    return this.http.get(`${this.uri}/search/addresses/brasil/${data}`);
  }

  public locationWithZipCode(id: string): Observable<any> {
    return this.http.get<IAddress>(`${this.uri}/products`).pipe(map(response => {
      return response.payload.filter(x => x.id === id);
    }));
  }

  public sendingForm(data) {
    return this.requestForm.next(data);
  }

  public receivingForm(): Observable<any> {
    return this.requestForm.asObservable();
  }

  public validatorForm(data) {
    return this.requestFormValidator.next(data);
  }

  public receivingValidatorForm(): Observable<any> {
    return this.requestFormValidator.asObservable();
  }

  public autoComplete(data: string): Observable<any> {
    return this.http.post(`${this.uri}/autocomplete/information/product`, {value: data});
  }

  public getProducts(data): Observable<any> {
    return this.http.post(`${this.uri}/products/additional-information`, data);
  }
}
